// src/lib/spinPrizes.js
// Prize definitions for the hidden /spin promo wheel, and the weighted
// random draw + redemption code generator that back it.
//
// Order here is also the order prizes appear around the wheel (12 slices,
// 30° each) — index i in PRIZES maps 1:1 to wheel slice i. Every slice has
// equal weight, so the odds of landing on a given prize are just its slice
// count out of 12 (e.g. 10% Off fills 3 slices -> 25% chance).
//
// Slice breakdown: 3x 10% Off, 3x Free Sample Set, 1x €5 Off, 1x €10 Off
// €75+, 1x 15% Off, 1x 20% Off, 1x 25% Off, 1x Mystery Prize. Repeated
// prizes are spread evenly round the wheel, and the slice count is kept
// even so the dark/gold slices alternate all the way round.

export const PRIZES = [
    { id: 'discount10a', label: '10% Off',                          shortLabel: '10% OFF',      weight: 1, codePrefix: 'MD10' },
    { id: 'samplesa',    label: 'Free Sample Set with Your Order',  shortLabel: 'FREE SAMPLES', weight: 1, codePrefix: 'MDSAMPLE' },
    { id: 'eur5',        label: '€5 Off',                           shortLabel: '€5 OFF',       weight: 1, codePrefix: 'MDE5' },
    { id: 'discount15',  label: '15% Off',                          shortLabel: '15% OFF',      weight: 1, codePrefix: 'MD15' },
    { id: 'discount10b', label: '10% Off',                          shortLabel: '10% OFF',      weight: 1, codePrefix: 'MD10' },
    { id: 'samplesb',    label: 'Free Sample Set with Your Order',  shortLabel: 'FREE SAMPLES', weight: 1, codePrefix: 'MDSAMPLE' },
    { id: 'mystery',     label: 'Mystery Prize',                    shortLabel: 'MYSTERY',      weight: 1, codePrefix: 'MDMYSTERY' },
    { id: 'discount20',  label: '20% Off',                          shortLabel: '20% OFF',      weight: 1, codePrefix: 'MD20' },
    { id: 'discount10c', label: '10% Off',                          shortLabel: '10% OFF',      weight: 1, codePrefix: 'MD10' },
    { id: 'samplesc',    label: 'Free Sample Set with Your Order',  shortLabel: 'FREE SAMPLES', weight: 1, codePrefix: 'MDSAMPLE' },
    { id: 'eur10',       label: '€10 Off Orders Over €75',          shortLabel: '€10 OFF €75+', weight: 1, codePrefix: 'MDE10' },
    { id: 'discount25',  label: '25% Off',                          shortLabel: '25% OFF',      weight: 1, codePrefix: 'MD25' },
];

const TOTAL_WEIGHT = PRIZES.reduce((sum, p) => sum + p.weight, 0);

// Picks a prize using its weight out of the total pool (does not depend on
// wheel slice position — "10% Off" appearing at three slice positions is
// purely visual, its real odds come from summing those slices' weights).
export function pickWeightedPrize() {
    let r = Math.random() * TOTAL_WEIGHT;
    for (const prize of PRIZES) {
        if (r < prize.weight) return prize;
        r -= prize.weight;
    }
    return PRIZES[PRIZES.length - 1];
}

// Excludes visually ambiguous characters (0/O, 1/I) so codes are easy to
// read off a phone screen at an event.
const CODE_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

function randomCodeSuffix(length = 6) {
    const bytes = new Uint8Array(length);
    window.crypto.getRandomValues(bytes);
    let out = '';
    for (let i = 0; i < length; i++) {
        out += CODE_CHARS[bytes[i] % CODE_CHARS.length];
    }
    return out;
}

export function generateRedemptionCode(prize) {
    return `${prize.codePrefix}-${randomCodeSuffix()}`;
}

export function todayKey() {
    return new Date().toISOString().slice(0, 10); // YYYY-MM-DD (UTC)
}
